import React from 'react';
import {
    Button,
    FormControl,
    OutlinedInput,
    InputLabel,
    Select,
    TextField,
    MenuItem,
} from '@mui/material';
import { Form, Label, Input } from 'reactstrap';
import "./CompanyViews.css";
import { useCompanyUsers } from '../../hooks/useCompanyUsers';
import { useCreateLicense } from '../../hooks/useLicenses';
import { EMPTY_GUID } from '../../query/queryConfig';
import { useAdminCompany } from '../../context/AdminCompanyContext';

function CompanyLicensingCreation(selectedCompProp){
    const createLicense = useCreateLicense();
    const [timeLength, setTimeLength] = React.useState(0);
    const [quant, setQuant] = React.useState();
    const [expirationTime, setExpirationTime] = React.useState(false);
    const [notes, setNotes] = React.useState();
    const { companyData: companySelection } = useAdminCompany();
    const [selectedComp, setSelectedComp] = React.useState(selectedCompProp.selectedCompProp);
    const [selectedUser, setSelectedUser] = React.useState(EMPTY_GUID);
    const { data: companyUsers = [] } = useCompanyUsers({
        companyId: selectedComp,
        menuType: 2,
        enabled: Boolean(selectedComp && selectedComp !== EMPTY_GUID),
    });

    let LicenseDTO = {
        LicenseQuantity: quant,
        Expiration: timeLength,
        Notes: notes,
        UserId: selectedUser
    };

    ///create new license
    function submitLicense(){
        createLicense.mutate(LicenseDTO);
        setExpirationTime(false);
        setQuant();
        setTimeLength();
        setNotes();
    };

    function checkBoxMarker(){
        setExpirationTime(!expirationTime);
        setTimeLength(0);
    }

    return(
        <div>
            <h1>Licensing Generator</h1>
            <Form style={{width:"100%", margin: 'auto'}}>
                <Label>Create any number of Licenses with a set expiration length.</Label>
                <br/>
                <Label>A user can be pre assigned to a given license but is not required. Can leave company and user field blank.</Label>
                <br/>
                <br/>
                <FormControl style={{width:'75%', margin:5}}>
                    <p>{companySelection.name}</p>
                </FormControl>
                <br/>
                <FormControl style={{width:'75%', margin:5}}>
                    <InputLabel id="demo-simple-select-label">Users</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={selectedUser}
                        label="Users"
                        onChange={(event) => setSelectedUser(event.target.value)}
                    >
                        {companyUsers.map((item) =>(
                            <MenuItem value={item.id}>{item.firstName} {item.lastName}</MenuItem>
                        ))}
                    </Select>
                </FormControl>
                <br/>
                <br/>
                <FormControl sx={{ m: 1 }}>
                    <Label htmlFor="outlined-adornment-amount">License Quantity</Label>
                    <OutlinedInput
                        type="number"
                        id="outlined-adornment-amount"
                        onChange={(event)=>setQuant(event.target.value)}
                    />
                </FormControl>

                <FormControl sx={{ m: 1 }}>
                    <Label>Select to generate perptual License, <br/> leave license length blank and check the box.</Label>
                    <Label check>
                        <Input type="switch" role="switch"
                            checked={expirationTime}
                             onChange={() => checkBoxMarker()}
                        />
                            Create Perpetual License
                    </Label>
                </FormControl>

                { expirationTime === false ?
                    <FormControl sx={{ m: 1 }}>
                        <Label htmlFor="outlined-adornment-amount">License Time Length</Label>
                        <Select
                        native
                        value={timeLength}
                        onChange={(event)=>setTimeLength(event.target.value)}
                        >
                            <option aria-label="None" value="" />
                            <option value={31}>30 Day</option>
                            <option value={366}>365 Day</option>
                        </Select>
                    </FormControl>
                    :
                    <div></div>
                }
                <br/>
                <FormControl className="licenceNotes" sx={{ m: 2 }} style={{width:'50%'}}>
                    <Label htmlFor="outlined-adornment-amount">License Notes</Label>
                    <TextField multiline rows={8} value={notes} onChange={(event)=>setNotes(event.target.value)}></TextField>
                </FormControl>
                <br/>
                <Button color="primary" variant="contained" onClick={()=>submitLicense()}>
                    Generate
                </Button>
            </Form>
        </div>
    )
};

export default CompanyLicensingCreation;